import React, { useCallback, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
//import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
//import OutsideClickHandler from "react-outside-click-handler";
import cn from "classnames";
import styles from "./Modal.module.sass";
import Icon from "../Icon";

const Modal = ({
      outerClassName
    , containerClassName
    , visible
    , onClose
    , children
    , onOutsideClick
    , showCloseButton
}) => {

    console.debug('components/Modal()', );
    console.debug('onClose = ', onClose);

    const escFunction = useCallback(
        (e) => {
            console.debug('components/Modal: e = ', e);
            if (e.keyCode === 27) {
                onClose();
            }
        }
        , [onClose]
    );

    useEffect(() => {
        document.addEventListener("keydown", escFunction, false);
        return () => {
            document.removeEventListener("keydown", escFunction, false);
        };
    }, [escFunction]);

    const scrollRef = useRef(null);

    /*
    useEffect(() => {
        console.debug('components/Modal: useEffect(() => { visible = ', visible);
        visible ? disableBodyScroll(scrollRef) : enableBodyScroll(scrollRef);
    }, [visible]);
    */

    return createPortal(
        visible
        && (
            <div
                className={styles.modal}
                ref={scrollRef}
                >
                <div
                    //className={styles.modal}
                    className={styles.modalWrapped}
                    //ref={scrollRef}
                    >
                    <div
                        className = { cn(styles.outer, outerClassName) }>
                        {/*
                        <OutsideClickHandler
                            //onOutsideClick = { onClose }
                            //onOutsideClick = { onOutsideClick }
                            onOutsideClick = { onOutsideClick || onClose }
                            useCapture = { false }
                            >
                        */}
                            <div className={cn(styles.container, containerClassName)}>
                                { children }

                                {
                                    showCloseButton
                                    &&
                                        <button className={styles.close} onClick={onClose}>
                                            <Icon name="close" size="14" />
                                        </button>
                                }
                            </div>
                        {/*
                        </OutsideClickHandler>
                        */}
                    </div>
                </div>
            </div>
        ),
        document.body
      );
};

export default Modal;
